import { render, staticRenderFns } from "./SuspiciousEventChecks.vue?vue&type=template&id=04fefe56&scoped=true&"
import script from "./SuspiciousEventChecks.vue?vue&type=script&lang=js&"
export * from "./SuspiciousEventChecks.vue?vue&type=script&lang=js&"
import style0 from "./SuspiciousEventChecks.vue?vue&type=style&index=0&id=04fefe56&lang=scss&scoped=true&"
import style1 from "./SuspiciousEventChecks.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fefe56",
  null
  
)

export default component.exports